export const NEXT_EVENTS_COLUMNS = [
  { id: 'event', label: 'Event', alwaysVisible: true, defaultVisible: true, sortable: false },
  { id: 'date', label: 'Date', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'venue', label: 'Venue', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'days_until', label: 'Days Until', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'tickets_sold', label: 'Tickets Sold', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'sold_today', label: 'Sold Today', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'sold_last_7', label: 'Sold Last 7d', alwaysVisible: false, defaultVisible: true, sortable: false },
  { id: 'sold_last_14', label: 'Sold Last 14d', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'pct_to_capacity', label: 'Pct to Capacity', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'forecast', label: 'Forecast', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'expected_finish', label: 'Expected Finish', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'presenter', label: 'Presenter', alwaysVisible: false, defaultVisible: false, sortable: false },
  { id: 'sold_yesterday', label: 'Sold Yesterday', alwaysVisible: false, defaultVisible: false, sortable: false },
];

export const getDefaultVisibleColumns = () =>
  NEXT_EVENTS_COLUMNS.filter(c => c.defaultVisible);

export const getDefaultHiddenColumns = () =>
  NEXT_EVENTS_COLUMNS.filter(c => !c.defaultVisible && !c.alwaysVisible);
